export class PhoneTypeLang {
    public Fax: string;
    public Mobile: string;
    public Pager: string;
    public Phone: string;
}


// WEBPACK FOOTER //
// ./src/resources/PhoneTypeLang.ts